import React from 'react';
import './App.css';
import Dashboard from './Components/Dashboard';
import Header from './Components/Header';

function App() {
  return (
    <div className="App">
      <Header />
      <Dashboard />
    </div>
  );
}

export default App;
